/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum constraint_scopes {
  ROSTER = 'Roster',
  PARENT = 'Parent',
  FORCE = 'Force',
}
